// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2xVVy","name":"styles_name__-UlJk","label":"styles_label__1c01d","subTitle":"styles_subTitle__2kkYp","list":"styles_list__1WaHY","item":"styles_item__1exDd"};